<div class="flex flex-column align-items-center justify-content-center">
  <h3 class="text-center mb-3">
    Scopri chi sono i <span class="green">Tour Leader</span> che organizzano i
    viaggi!<img class="ml-2" src="/assets/media/icons/tour-guide.png" />
  </h3>
  <span class="text-center grey-text"
    >Viaggiatori appassionati con esperienza sul campo, pronti a guidarti in
    ogni tappa dell'avventura. La loro presenza è garanzia di entusiasmo,
    sicurezza e coinvolgimento totale. Che tu stia partendo per la prima volta o
    sia un esploratore esperto, i Tour Leader sapranno trasformare ogni momento
    in un ricordo indimenticabile.</span
  >
</div>

<div class="flex justify-content-center mt-4 mb-5">
  <a class="more" (click)="gotoTourLeaders()">
    <span> Scopri i nostri Tour Leader </span>
    <i class="pi pi-arrow-circle-right"></i>
  </a>
</div>
